/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import UIFlex from 'UIComponents/layout/UIFlex';
import GoogleLoginDao from '../../data/GoogleLoginDao';
import googleLoginNonce from '../../lib/googleLoginNonce';
import HubSpotOnlyAppCookieLogin from 'Nabisco/app/HubSpotOnlyAppCookieLogin';
import LoginDao from '../../data/LoginDao';
const loginDao = new LoginDao();
const appCookieLogin = new HubSpotOnlyAppCookieLogin({
  loginRequest: loginDao.uiLogin.bind(loginDao),
  passThroughFallback: true
});
import LoginFailureHandlerFactory from '../../lib/LoginFailureHandlerFactory';
const googleLoginDao = new GoogleLoginDao();

const GoogleLoginButton = ({
  loginPortalId,
  loginRedirectUrl,
  triggerReset,
  history
}) => {
  const [googleId, setGoogleId] = useState();
  useEffect(() => {
    const credentials = {
      loginPortalId,
      loginRedirectUrl
    };
    googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndReturnGoogleId).then(data => {
      setGoogleId(data.googleId);
    }).then(() => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }).then(() => {
      window.handleCredentialResponse = response => {
        response.loginPortalId = loginPortalId;
        response.loginRedirectUrl = loginRedirectUrl;
        googleLoginDao.passCredentialResponse(response).then(result => {
          const setCsrfCookies = Promise.resolve(appCookieLogin.collectLoginResponses(result));
          setCsrfCookies.then(appCookieLogin.redirectOnLoginSuccess([result]));
        }).catch(err => {
          LoginFailureHandlerFactory.create(triggerReset, history.push)(err);
        });
      };
    }); // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "GOOGLE_LOGIN_LOAD",
    children: [/*#__PURE__*/_jsx("div", {
      className: "g_id_signin",
      "data-type": "standard",
      "data-width": "400",
      style: {
        maxHeight: '40px',
        marginBottom: '14px'
      }
    }), /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      align: "center",
      children: /*#__PURE__*/_jsx("div", {
        id: "g_id_onload",
        "data-client_id": googleId,
        "data-callback": "handleCredentialResponse",
        "data-auto_prompt": "false",
        "data-cancel_on_tap_outside": "false"
      })
    })]
  });
};

export default GoogleLoginButton;